import MetaHead from '../components/MetaHead';
import GalleryModal from '../components/GalleryModal';
import PhoneCTA from '../components/PhoneCTA';
import EmailCTA from '../components/EmailCTA';

export default function KlinikkenPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12">
      <MetaHead 
        title="Klinikken - Din Privat Psykolog"
        description="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogTitle="Klinikken i Gram - Din Privat Psykolog"
        ogDescription="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogImage="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/7f0d58f1-d94f-4b01-b1cd-7d855932c06a.jpg"
      />

      {/* Header */}
      <div className="border-b border-[#E0D7C6] pb-8 space-y-3">
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Klinikken i Gram
        </h1>
        <p className="text-base sm:text-lg text-[#3B4D42] max-w-3xl leading-relaxed">
          Privatklinikken ligger på 1. sal i min rødstensvilla fra 1926.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-8 space-y-8">
          
          {/* Main Description */}
          <div className="space-y-4 text-sm sm:text-base text-[#5f7365] leading-relaxed">
            <h2 className="font-serif text-2xl font-bold text-[#5f7365]">
              Velkommen til Privatklinikken
            </h2>
            <p>
              Privatklinikken ligger på 1. sal i min rødstensvilla fra 1926. Du går ind af den grønne havelåge, opad flisegangen og ringer på klokken ved den første dør, du kommer til. Der står <em>Privatpsykolog</em> på døren. Jeg glæder mig til at byde dig velkommen.
            </p>
          </div>

          {/* Featured Clinic Photos Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-2">
            <div className="overflow-hidden border border-[#EDE6D8] bg-white shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/7f0d58f1-d94f-4b01-b1cd-7d855932c06a.jpg"
                alt="Klinikken på Torvegade 8 i Gram - Rødstensvilla"
                className="w-full h-56 object-cover object-center"
              />
              <div className="p-3 bg-[#FAF8F5]">
                <p className="font-semibold text-xs text-[#5f7365]">Rødstensvillaen i Gram</p>
                <p className="text-[11px] text-[#5A7364]">Klinikken er beliggende på 1. sal i rolige omgivelser</p>
              </div>
            </div>

            <div className="overflow-hidden border border-[#EDE6D8] bg-white shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/4320192f-3e8c-4ece-bf20-999699adc5ee.jpeg"
                alt="Indgang til Privat Psykolog"
                className="w-full h-56 object-cover object-center"
              />
              <div className="p-3 bg-[#FAF8F5]">
                <p className="font-semibold text-xs text-[#5f7365]">Indgang via flisegangen</p>
                <p className="text-[11px] text-[#5A7364]">Gå gennem havelågen til døren mærket Privatpsykolog</p>
              </div>
            </div>
          </div>

          {/* Sponsorater & Lokalt engagement */}
          <div className="pt-8 border-t border-[#EDE6D8] space-y-5">
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#5f7365]">
                <i className="fa-solid fa-heart-pulse text-red-600" />
                <span>Engagement</span>
              </div>
              <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#5f7365]">
                Sponsorater
              </h2>
              <p className="text-sm sm:text-base text-[#384A3F] leading-relaxed">
                Klinikken vil gerne være med til at støtte gode sager, foreninger og øvrige tiltag i lokalområdet.
              </p>
            </div>

            {/* Projekt: Start et hjerte, red et liv */}
            <div className="bg-[#FAF8F5] border border-[#EDE6D8] p-5 sm:p-6 shadow-xs flex flex-col sm:flex-row gap-6 items-start">
              <div className="w-full sm:w-5/12 shrink-0 overflow-hidden border border-[#EDE6D8] bg-white relative">
                <img
                  src="/cdn-cgi/image/width=800,quality=85,format=auto/_assets/start-et-hjerte-red-et-liv-sponsorat.jpg"
                  alt="Projekt: Start et hjerte, red et liv - Sponsoreret af Din Privat Psykolog"
                  className="w-full h-48 sm:h-52 object-cover object-center"
                />
                <span className="absolute bottom-2 right-2 text-[10px] bg-black/65 text-white px-2 py-0.5 backdrop-blur-xs font-medium">
                  Placeholder foto
                </span>
              </div>

              <div className="w-full sm:w-7/12 space-y-3">
                <div className="inline-flex items-center gap-2 px-2.5 py-1 bg-white border border-[#EDE6D8] text-[11px] font-semibold text-[#5f7365]">
                  <i className="fa-regular fa-calendar-check text-xs" />
                  <span>Sponsorat 2026 og 2027</span>
                </div>
                <h3 className="font-serif text-lg sm:text-xl font-bold text-[#5f7365]">
                  Start et hjerte, red et liv
                </h3>
                <p className="text-sm text-[#384A3F] leading-relaxed">
                  I 2026 og 2027 er jeg medsponsor/støtte for projekt: <strong>Start et hjerte, red et liv</strong>.
                </p>
                <p className="text-xs text-[#5A7364] leading-relaxed pt-1">
                  Et værdifuldt lokalt initiativ, som skaber tryghed og redder liv ved at styrke adgangen til hjertestartere og livreddende førstehjælp i lokalområdet.
                </p>
              </div>
            </div>
          </div>

          {/* Dynamic Gallery connected via CMS slug */}
          <div className="pt-8 border-t border-[#EDE6D8] space-y-4">
            <h2 className="font-serif text-xl sm:text-2xl font-bold text-[#5f7365]">
              Billeder fra klinikken
            </h2>

            {/* Dynamic CMS Gallery component linked via slug 'klinikken-galleri' */}
            <GalleryModal slug="klinikken-galleri" />
          </div>

        </div>

        {/* Sidebar: Practical Details */}
        <div className="lg:col-span-4 space-y-6">
          <div className="space-y-4">
            <h3 className="font-serif font-bold text-lg text-[#5f7365]">
              Ankomst & praktisk info
            </h3>
            
            <div className="space-y-3 text-xs sm:text-sm text-[#384A3F]">
              <div className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot text-[#5f7365] mt-1 shrink-0" />
                <div>
                  <p className="font-semibold text-[#5f7365]">Adresse</p>
                  <p>Torvegade 8, 1. sal</p>
                  <p>6510 Gram</p>
                </div>
              </div>

              <div className="flex items-start gap-3 border-t border-[#E5DFD1] pt-3">
                <i className="fa-regular fa-door-open text-[#5f7365] mt-1 shrink-0" />
                <div>
                  <p className="font-semibold text-[#5f7365]">Ankomst</p>
                  <p className="text-xs leading-relaxed">
                    Gå igennem den grønne havelåge, op ad flisegangen og ring på døren mærket <em>Privatpsykolog</em>.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 border-t border-[#E5DFD1] pt-3">
                <i className="fa-regular fa-couch text-[#5f7365] mt-1 shrink-0" />
                <div>
                  <p className="font-semibold text-[#5f7365]">Ankomsttidspunkt</p>
                  <p className="text-xs leading-relaxed">
                    Der er ikke venteværelse. For at beskytte klienters anonymitet bedes du ringe på præcist ved aftalt tid.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-3 border-t border-[#E5DFD1]">
              <a
                href="https://www.google.com/maps/search/?api=1&query=Din+Privat+Psykolog,+Torvegade+8,+6510+Gram"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-2.5 px-3 bg-white hover:bg-[#F8F5EE] border border-[#D5CEBF] text-[#5f7365] font-semibold rounded-none text-xs flex items-center justify-center gap-2 transition-all duration-200 hover:-translate-y-1 shadow-2xs"
              >
                <i className="fa-regular fa-map-location-dot text-[#5f7365]" />
                <span>Find vej på Google Maps</span>
                <i className="fa-regular fa-arrow-up-right-from-square text-[10px]" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CTAs */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6">
        <PhoneCTA />
        <EmailCTA />
      </div>
    </div>
  );
}
